export default {
  data: () => ({
    mixinHeights: { tools: 0, header: 0 },
  }),
  props: {
    stickyTarget: {
      type: Object,
      default: null,
      validator: (stickyTarget) => {
        const keys = Object.keys(stickyTarget);
        const sets = [['$refs', 'key'], ['container', 'query']];
        const isValid = sets.some((set) => set.every((key) => keys.includes(key)));
        if (!isValid) {
          console.error(`
            Missing props, must include the following keys in pairs:
            Required: ${sets.map((set) => `{${set}}`).join(' || ')}
            Received Set: ${keys}
          `);
        }
        return isValid;
      },
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.stickyHeader) {
      this.mixinSetHeight()
      window.addEventListener('resize', this.mixinSetHeight);
    }
  },
  destroyed() {
    if (this.stickyHeader) {
      window.removeEventListener('resize', this.mixinSetHeight);
    }
  },
  computed: {
    mixinTableStyles() {
      const styles = {
        '--table-thead-index': this.styles.theadIndex || '3',
        '--table-tools-index': this.styles.toolsIndex || '4',
        '--table-header-index': this.styles.headerIndex || 'unset',
        '--table-thead-top': this.styles.theadTop || this.mixinHeights.header,
        '--table-tools-top': this.styles.toolsTop || this.mixinHeights.tools,
        '--table-header-top': this.styles.headerTop || 'unset', 
      };
      return styles;
    },
    mixinBulkActionStyles() {
      const { bActions = {} } = this.styles || {};
      const opts = {
        zIndex: bActions.index || '5',
        position: bActions.position || 'sticky',
        height: bActions.height || 'fit-content',
        top: bActions.top || this.mixinTableStyles['--table-tools-top'],
      }
      return opts;
    },
  },
  methods: {
    mixinSetHeight() {
      const opts = { tools: null, header: 0 };
      const { toolsTopOffset = -16, theadTopOffset = 0 } = this.styles;
      const headerElement = this.mixinFetchHeaderElement();
      const filterElement = this.mixinFetchRefElement(null, 'tools');
      const bulkElement = this.mixinFetchRefElement(null, 'bulkActions');
      /** Calculate tools top */
      const { height: headerHeight = 0 } =  headerElement ? headerElement.getBoundingClientRect() : {};
      if (headerHeight) opts.tools = headerHeight + toolsTopOffset;
      else if (filterElement) opts.tools = 0;
      /** Calculate thead top */
      const { height: filterHeight = 0 } = filterElement ? filterElement.getBoundingClientRect() : {};
      const { height: bulkHeight = 0 } = bulkElement ? bulkElement.getBoundingClientRect() : {};
      const filterOffset = opts.tools + Number.parseInt(filterHeight > bulkHeight ? filterHeight : bulkHeight) + theadTopOffset;
      this.mixinHeights = {
        tools: opts.tools !== null ? `${opts.tools}px` : 'unset',
        header: filterOffset ? `${filterOffset}px` : 'unset',
      };
    },
    mixinFetchHeaderElement() {
      const { container = this.$parent, query = '.vcl-widget__header', $refs, key= '' } = (this.stickyTarget || {});
      let element = $refs ? $refs[key] : null;
      if (!element) element = this.mixinFetchRefElement(container, key, query);
      return element;
    },
    mixinFetchRefElement(container, ref, query) {
      const target = this.$refs[ref] || container;
      const $el = target && target._isVue ? target.$el : target;
      return query ? $el && $el.querySelector(query) : $el;
    }
  },
}